var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"card-release"},[_c('b-col',{attrs:{"md":"auto"}},[_c('div',{staticClass:"card-release__title py-2 m-0"},[_vm._t("label")],2)]),_c('b-col',[_c('div',{staticClass:"p-2"},[_vm._t("value")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }